import { Input, Directive, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
    selector: '[focus]'
})

export class AutofocusDirective {

    @Input() focus: Directive;
    constructor(private element: ElementRef) {
    }

    ngAfterViewInit() {
        if (this.focus) {
            this.element.nativeElement.focus();
        }
    }
}



// WEBPACK FOOTER //
// ./SignClient/app/shared/directives/autofocus.directive.ts